export default __webpack_public_path__ + "static/rec-2024-685e5e40b82b3f6d7afba7d486f4ec02.png";